// extracted by mini-css-extract-plugin
module.exports = {"tooltipDarkTheme":"tooltipDarkTheme__6M53L","tooltipArrowDarkTheme":"tooltipArrowDarkTheme__14eGj"};